export default __webpack_public_path__ + "static/media/illustrate.64f3a199.svg";